import type { ReactNode } from 'react';

export function EmptyState({ children }: { children: ReactNode }) {
  return (
    <p className="border border-dashed border-line px-3 py-3 text-sm text-faint">{children}</p>
  );
}
